import { useBreakpoint } from '@one-thd/sui-atomic-components';

export const useSlidesPer = (renderWidths, slidesPerKey) => {
  const { lesser: isMobile } = useBreakpoint('lg');
  const { greater: isDesktop } = useBreakpoint('md');

  if (!slidesPerKey || !renderWidths) {
    return null;
  }

  let windowWidth;
  if (isMobile) {
    windowWidth = 'maxWidthMedium';
  } else if (isDesktop) {
    windowWidth = 'minWidthLarge';
  } else {
    windowWidth = 'minWidthMedium';
  }

  return windowWidth === 'maxWidthMedium'
    ? null
    : slidesPerKey[windowWidth][+renderWidths[windowWidth]];
};